// =====================================================================
// SIMULATORE AI PRODIGY — TESTI DELLA SCHERMATA RISULTATO (modificabili)
// =====================================================================

export const ETICHETTE = {
  eyebrow: "Profilo simulato",
  archetipo: "Archetipo",
  forza: "Punti di forza",
  sviluppo: "Aree di sviluppo ideale",
  contesti: "Contesti ideali",
  team: "Nel team",
};

// Blocco di chiusura dopo l'analisi.
export const CHIUSURA = {
  eyebrow: "E adesso?",
  titolo: "Questa è solo un'anteprima.",
  paragrafi: [
    "In pochi minuti hai visto emergere un profilo. Il test completo va molto più in profondità: è redatto da psicologi, elaborato con l'AI e restituisce una mappatura dettagliata di come pensi, decidi e lavori.",
    "Non sei un pezzo di carta. Eppure, mentre il tuo CV resta uguale a tutti gli altri, chi seleziona continua a vedere solo titoli ed esperienze. Il tuo modo di affrontare i problemi rimane invisibile.",
    "Con Prodigy decidi tu come farti trovare: in modalità blind o in chiaro. E non costa nulla.",
  ],
  benefici: [
    { titolo: "CV moderno gratuito", testo: "Un curriculum dal design curato, pronto in pochi minuti e senza costi." },
    { titolo: "Test psico-attitudinale completo", testo: "Redatto da psicologi e arricchito dall'analisi AI del tuo profilo." },
    { titolo: "Grafico a radar nel CV", testo: "Il tuo profilo attitudinale diventa un elemento visivo integrabile nel curriculum." },
    { titolo: "Pool Premium e privacy totale", testo: "Entra nel radar delle aziende partner e scegli tu se restare blind o mostrarti in chiaro." },
  ],
  cta: "Questo era solo un test. Esegui la mappatura completa e crea il tuo CV.",
  ricomincia: "Ricomincia",
};
